import { useState } from 'react';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';
import { useDecks } from '@sorare/core/src/hooks/decks/useDecks';

import { DeckEditorDialog } from 'components/decks/DeckEditorDialog';

import { CustomDecksFilter } from '..';

type Props = {
  sport: Sport;
  visible: boolean;
};

export const SportCustomDecksFilter = ({ visible, sport }: Props) => {
  const [search, setSearch] = useState<string>('');
  const [creating, setCreating] = useState(false);
  const [editingDeckSlug, setEditingDeckSlug] = useState<string>();
  const { editableLists, galleryOwnerSlug } = useSearchCardsContext();
  const { decks, loading } = useDecks({
    sport,
    query: search,
    userSlug: editableLists ? undefined : galleryOwnerSlug,
  });

  return (
    <>
      <CustomDecksFilter
        decks={decks}
        loading={loading}
        search={search}
        setSearch={setSearch}
        onEditDeck={slug => setEditingDeckSlug(slug)}
        onCreateDeck={() => setCreating(true)}
        visible={visible}
      />
      {!!(editingDeckSlug || creating) && (
        <DeckEditorDialog
          sport={sport}
          slug={editingDeckSlug}
          onClose={() => {
            setEditingDeckSlug(undefined);
            setCreating(false);
          }}
        />
      )}
    </>
  );
};
